'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Left = require('./Left');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Left).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Arrows/light/Left/index.js
// module id = 53
// module chunks = 0 1 2 3 4 5 6 7 8 9